<template lang="pug">
    div#main-header
        nav.navbar.is-transparent(role="navigation")

            div.navbar-brand
                router-link(to="/")
                    a.navbar-item
                        img.logo(:src="`${baseUrl}` + 'img/LOGO_WHITE_BG_small.png'")

            div#navMenu.navbar-menu.is-active
                div.navbar-end
                    div.field.buttons.has-text-light
                        router-link(to="/")
                            a.button
                                strong Home 
                        router-link(to="/aboutus")
                            a.button
                                strong About Us
                        router-link(to="/services")
                            a.button
                                strong Services
                        router-link(to="/products")
                            a.button
                                strong Products
                        router-link(to="/rnd")
                            a.button
                                strong R&D
                        router-link(to="/gallery")
                            a.button
                                strong Gallery
                        router-link(to="/contact")
                            a.button
                                strong Contact Us
        div 
            Breadcrumb
                        
                        
</template>

<script>
import Breadcrumb from './Breadcrumb.vue';
export default {
    components: {
        Breadcrumb
    },

    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
        };
    },

    computed: {
        name: function() {
            return this.$route.name
        },

        list: function () {
            return this.$route.matched
        }
    }
}
</script>

<style scoped>
.navbar {
    background-color: rgba(255, 0, 0, 0);
    margin-bottom: 0.8rem;
}

@media screen and (max-width: 1087px) {
    .navbar-menu {
        background-color: rgba(255, 0, 0, 0);
    }

}

a {
    background-color: #E8E8E8;
}

.logo {
    max-height: 5rem;
}

.button {
    border-style: none;
}
</style>

